export enum ClientName {
    LICARD = 'licard',
    LICARD_UAT = 'licard-uat',
}

type ClientRecordType<T> = {
    [key: string]: T;
};

interface ClientsData {
    helpLinks: ClientRecordType<string>;
}

export default {
    helpLinks: {
        [ClientName.LICARD_UAT]: 'http://wiki-spa-uat.licard.com/ru/home',
        default: 'http://wiki.smartpricing.cloud/manual',
    },
} as ClientsData;
